import React from 'react'
import Link from 'gatsby-link'

import Banner from '../components/banner'

import Sectiontitle from '../components/sectionTitle'
import Button from '../components/button'

import accident from '../policies/accident_illness_policy.pdf';
import abuse from '../policies/allegations_of_abuse.pdf';
import behaviour from '../policies/behaviour_management.pdf';
import complaints from '../policies/complaints_policy.pdf';
import confidentiality from '../policies/confidentiality_policy.pdf';
import emergency from '../policies/emergency_plan.pdf';
import parentuser from '../policies/eyfs_parent_guide_user_guide.pdf';
import parentguide from '../policies/eyfs_parent_guide.pdf';
import healthsafety from '../policies/health_safety.pdf';
import healthyeating from '../policies/healthy_eating.pdf';
import inclusion from '../policies/inclusion.pdf';
import lostchild from '../policies/lost_child.pdf';
import medicine from '../policies/medicine.pdf';
import noncollection from '../policies/non_collection_of_child.pdf';
import risk from '../policies/risk_assessment.pdf';
import safeguarding from '../policies/safeguarding_children.pdf';
import patnership from '../policies/working_in_partnership_with_parents.pdf';

const Policy = () => (
  <div className="policy">
    <Banner type="policy" title="Our Policies" />
    <section className="page-grid">
      	<section className="page-grid-section first">
			<div className="container">
				<div className="rc-copy">
					Here is a list of my childcare contract and policies:
				</div>
				<br/><br/>
				<div className="policy-block">
					<Sectiontitle title="Accident Illness Policy" />
					<Button text="View" action="true" link={accident} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="allegations of abuse" />
					<Button text="View" action="true" link={abuse} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Behaviour Management Policy" />
					<Button text="View" action="true" link={behaviour} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Complaints Policy" />
					<Button text="View" action="true" link={complaints} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Confidentiality Policy" />
					<Button text="View" action="true" link={confidentiality} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Emergency Plan Policy" />
					<Button text="View" action="true" link={emergency} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="EYFS Parent Guide - User Guide" />
					<Button text="View" action="true" link={parentuser} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="EYFS Parent Guide" />
					<Button text="View" action="true" link={parentguide} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Health &amp; Safety Policy" />
					<Button text="View" action="true" link={healthsafety} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Healthy Eating Policy" />
					<Button text="View" action="true" link={healthyeating} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Inclusion Policy" />
					<Button text="View" action="true" link={inclusion} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Lost Child Policy" />
					<Button text="View" action="true" link={lostchild} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Medicine Policy" />
					<Button text="View" action="true" link={medicine} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Non Collection of Child Policy" />
					<Button text="View" action="true" link={noncollection} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Risk Assessment Policy" />
					<Button text="View" action="true" link={risk} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Safeguarding Children Policy" />
					<Button text="View" action="true" link={safeguarding} target="blank"/>
				</div>

				<div className="policy-block">
					<Sectiontitle title="Working In Partnership With Parents Policy" />
					<Button text="View" action="true" link={patnership} target="blank"/>
				</div>

			</div>
		</section>
    </section>
  </div>
)

export default Policy



// WEBPACK FOOTER //
// ./src/pages/policy.js